import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const empiricallabs: IBrand = {
  id: "empirical-labs",
  name: BRAND.EMPIRICAL_LABS,
  logo: "/img/empirical_logo_black.png",
  website: "https://www.empiricallabs.com/",
  description: `
ELI was started in 1988 and functioned mainly as a recording studio and electronic consulting firm. 
The founder, Dave Derr, was also employed at the time by Eventide as an audio engineer where he was part of the core design team for the H3000, H3500, and DSP4000. 
His experience at Eventide proved invaluable for his later work. 

While working alongside Ken Bogdanowicz and Bob Belcher (both now at Soundtoys), Dave was exposed to state of the art engineering and the modern world of digital signal processing (DSP). 
The first Empirical Labs product – the Distressor – was designed in 1994, tested and revised for several years, and released in 1996. 

With over twenty-five thousand units sold, it has unquestionably become a modern classic. 
In 1998, Empirical Labs closed the doors of the recording studio to focus on the growing signal processing business. 
Today, all Empirical Labs products are still manufactured in the USA and rigorously calibrated and tested by hand.
`,
  videos: [
    "https://www.youtube.com/embed/dDWbuQ0pmYk",
  ],
}